import React from "react";

import styled from "styled-components/macro";

import { NavLink, useParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { format, parseISO } from "date-fns";
import { pt } from "date-fns/locale";

import { blue } from "@material-ui/core/colors";

import {
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";

import * as Icons from "@material-ui/icons";

import { spacing } from "@material-ui/system";

import { AgentsService } from "../../services";

const Box = styled(MuiBox)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

export const AgentThreadsPage = () => {
  const [agent, setAgent] = React.useState(null);

  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState([]);

  const { agentId } = useParams();

  React.useEffect(() => {
    (async () => {
      const resAgent = await AgentsService.getById(agentId);
      setAgent(resAgent.data);
    })();
  }, [agentId]);

  React.useEffect(() => {
    (async () => {
      const resList = await AgentsService.listThreads(agentId, page);
      setData(resList.data);
    })();
  }, [agentId, page]);

  return (
    <Box p={8}>
      <Helmet title="Conversas do Agente" />

      <Grid justify="space-between" container>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Conversas
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/platform/agents">
              Agentes
            </Link>
            <Link
              component={NavLink}
              exact
              to={`/platform/agents/${agentId}/edit`}
            >
              {agent?.name}
            </Link>
            <Typography>Conversas</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <div>
            <Paper>
              <TableContainer>
                <Table aria-labelledby="tableTitle" size={"medium"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>TÍTULO</TableCell>
                      <TableCell>RESOURCE ID</TableCell>
                      <TableCell>CRIADO EM</TableCell>
                      <TableCell>ATUALIZADO EM</TableCell>
                      <TableCell align="center" style={{ minWidth: "150px" }}>
                        Ações
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.rows?.map((row, index) => {
                      return (
                        <TableRow>
                          <TableCell align="left" id={index} scope="row">
                            <strong>{row.title}</strong>
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.resourceId}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.createdAt &&
                              format(
                                parseISO(row.createdAt),
                                "PPPP 'às' p",
                                {
                                  locale: pt,
                                }
                              )}
                          </TableCell>

                          <TableCell align="left" id={index} scope="row">
                            {row.updatedAt &&
                              format(
                                parseISO(row.updatedAt),
                                "PPPP 'às' p",
                                {
                                  locale: pt,
                                }
                              )}
                          </TableCell>

                          <TableCell
                            align="right"
                            style={{ minWidth: "150px" }}
                          >
                            <Tooltip title="Mensagens">
                              <IconButton
                                component={NavLink}
                                to={`/platform/agents/${agentId}/threads/${row.id}/messages`}
                                style={{ color: blue[700] }}
                              >
                                <Icons.Message />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                labelDisplayedRows={({ from, to, count }) =>
                  `Página ${page + 1} de ${Math.ceil(count / 6)}`
                }
                rowsPerPageOptions={[6]}
                component="div"
                count={data.count || 0}
                rowsPerPage={6}
                page={page}
                onChangePage={(_, page) => setPage(page)}
              />
            </Paper>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
